/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import {ChangeFunction} from "@dvrd/dvr-controls";
import React from 'react';
import NotificationInputController from './notificationInput/notificationInputController';

interface Props {
    onChangeEmailAddresses: ChangeFunction<string>;
    emailAddresses: Array<string>;
    disabled: boolean;
}

export default function NotificationEmail(props: Props) {
    const {onChangeEmailAddresses, emailAddresses, disabled} = props;
    return (
        <section>
            <label className='fixed-text'>stuur een notificatie naar</label>
            <NotificationInputController onSubmit={onChangeEmailAddresses} value={emailAddresses.join(',')}
                                         label='Stuur notificatie naar'
                                         inputProps={{inputProps: {type: 'email', multiple: true}}}
                                         disabled={disabled}/>
        </section>
    )
}